export enum Clients{
    TDIS="TDIS",
    VERHEYEN="VERHEYEN",
    MEIJERS="MEIJERS",
    ATRALO="ATRALO"
}

export enum EnvironmentEnum{
    TDIS_TEST="TDIS_TEST",
    TDIS_PROD="TDIS_PROD",
    VERHEYEN_TEST="VERHEYEN_TEST",
    VERHEYEN_PROD="VERHEYEN_PROD",
    MEIJERS_TEST="MEIJERS_TEST",
    MEIJERS_PROD="MEIJERS_PROD",
    ATRALO_TEST="ATRALO_TEST",
    ATRALO_PROD="ATRALO_PROD",
}

export enum Logo{
    TDIS="../../../assets/images/TDISLogoT5V3.png",
    VERHEYEN="../../../assets/images/verheyen/verheyen-logo.svg",
    // VERHEYEN="../../../assets/images/verheyen/verheyen-logo-nav.png",
    MEIJERS="../../../assets/images/TDISLogoT5V3.png",
    ATRALO ="../../../assets/images/Atralo/logo_atralo_alternative_rgb.png",
}

export enum Loader{
    TDIS='../../assets/images/TDIS Icons/loader.gif',
    VERHEYEN='../../assets/images/verheyen/loader.gif',
    MEIJERS='../../assets/images/TDIS Icons/loader.gif',
    ATRALO='../../assets/images/TDIS Icons/loader.gif',
}

export enum Icons{
    TDIS='../../assets/images/icons/',
    VERHEYEN='../../assets/images/verheyen/icons/',
    MEIJERS='../../assets/images/icons/',
    ATRALO='../../assets/images/icons/',
}

export enum GoogleApiKey{
    TDIS_TEST="AIzaSyD6RrviKgFJL0AW_8HdOZJQWGaJOvx7Mpc",
    TDIS_PROD="AIzaSyB0E-Fh4Mbi6H6ZywSHu9_XAifL82x4nt8",
    VERHEYEN_TEST="AIzaSyD6RrviKgFJL0AW_8HdOZJQWGaJOvx7Mpc",
    VERHEYEN_PROD="AIzaSyB0E-Fh4Mbi6H6ZywSHu9_XAifL82x4nt8",
    MEIJERS_TEST="AIzaSyD6RrviKgFJL0AW_8HdOZJQWGaJOvx7Mpc",
    MEIJERS_PROD="AIzaSyB0E-Fh4Mbi6H6ZywSHu9_XAifL82x4nt8",
    ATRALO_TEST="AIzaSyD6RrviKgFJL0AW_8HdOZJQWGaJOvx7Mpc",
    ATRALO_PROD="AIzaSyB0E-Fh4Mbi6H6ZywSHu9_XAifL82x4nt8",
}


export enum GoogleCaptchaKey{
    TDIS_TEST="6LdsyAocAAAAABcjXHYabaXIU9F067QC4SYFb9fz",
    TDIS_PROD="6LdsyAocAAAAABcjXHYabaXIU9F067QC4SYFb9fz",
    VERHEYEN_TEST="6LdsyAocAAAAABcjXHYabaXIU9F067QC4SYFb9fz",
    VERHEYEN_PROD="6LdsyAocAAAAABcjXHYabaXIU9F067QC4SYFb9fz",
    MEIJERS_TEST="6LdsyAocAAAAABcjXHYabaXIU9F067QC4SYFb9fz",
    MEIJERS_PROD="6LdsyAocAAAAABcjXHYabaXIU9F067QC4SYFb9fz",
    ATRALO_TEST="6LdsyAocAAAAABcjXHYabaXIU9F067QC4SYFb9fz",
    ATRALO_PROD="6LdsyAocAAAAABcjXHYabaXIU9F067QC4SYFb9fz",
}


export enum ServerUrl{
    TDIS_TEST="http://localhost:8080/",
    TDIS_PROD="/marine/",
    VERHEYEN_TEST="http://localhost:8080/",
    VERHEYEN_PROD="/marine/",
    MEIJERS_TEST="http://localhost:8080/",
    MEIJERS_PROD="/marine/",
    ATRALO_TEST="http://localhost:8080/",
    ATRALO_PROD="/marine/",
}
